import { Component } from '@angular/core';
import { AppMainComponent } from './app.main.component';
import { Router } from '@angular/router';
import { Company } from './demo/domain/company';
import { CompanyService } from './demo/service/company.service';
import { JwtHelperService } from '@auth0/angular-jwt';
import { Configuration } from './demo/domain/configuration';
import * as $ from 'jquery';
import { LoginService } from './demo/service/login.service';

@Component({
    selector: 'app-topbar',
    templateUrl: './app.topbar.component.html'
})
export class AppTopBarComponent {

    companies: Company[];
    company: Company;
    response: any;
    currentPageTitle: String;

    constructor(public app: AppMainComponent, private router: Router,
                private companyService: CompanyService , 
                private loginService : LoginService,
                private jwtHelper : JwtHelperService) {
            companyService.get().then(objects => this.companies = objects).then(() => {

                this.company = JSON.parse(localStorage.getItem('currentCompany'));

                if (this.company == null)
                {
                    this.company = this.companies[0];
                    localStorage.setItem('currentCompany', JSON.stringify(this.company));
                    window.location.reload();
                }
            });

            this.router.routeReuseStrategy.shouldReuseRoute = function() {
                return false;
            };

        }

    ngOnInit() {
        const token = this.jwtHelper.decodeToken(localStorage.getItem('jwt'));
        var pictureLink = Configuration.server + '/api/users/' + token['http://schemas.xmlsoap.org/ws/2005/05/identity/claims/sid'] + '/photo';
        this.GetImage(pictureLink);
    }

    public GetImage(url)
    {
        var http = new XMLHttpRequest();
        http.open('GET', url, true);
        http.responseType = "blob";
        let token = localStorage.getItem('jwt');
        http.setRequestHeader('Authorization', 'Bearer ' + token);
        http.onload = this.loadImage;
        http.send();
    } 

    public loadImage(e) {
        var urlCreator = window.URL;
        var imageUrl = urlCreator.createObjectURL(this.response);
        $("#profilePhoto").attr('src', imageUrl);
    }

    onProfil() {
        const token = this.jwtHelper.decodeToken(localStorage.getItem('jwt'));

        this.router.navigate(['/usersrestricted/' + token['http://schemas.xmlsoap.org/ws/2005/05/identity/claims/sid']]);

    }

    onLogOut() {
        this.loginService.logout();
        this.router.navigate(['/login']);

    }

    onChange($event) {
        localStorage.setItem('currentCompany', JSON.stringify(this.company));
        this.router.navigate(['/reportdefinitions'],);
    }

    getName(){
        const token = this.jwtHelper.decodeToken(localStorage.getItem('jwt'));
        //console.log(token);

        return  token['http://schemas.xmlsoap.org/ws/2005/05/identity/claims/givenname'] + ' '
                 + token['http://schemas.xmlsoap.org/ws/2005/05/identity/claims/surname'];
    }
}
